/*
 * Copyright © 2022 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {Directive, effect, inject, input, untracked} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {NgControl} from '@angular/forms';
import type {UnparsedPermission} from '@dv/shared/code';
import {combineLatest} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {AuthorizationProviderService} from './../authorization-provider.service';

@Directive({
    selector: '[dvlibRequirePermission]:not(ng-template[dvlibRequirePermission])',
    host: {
        '[attr.disabled]': 'isDisabled()',
    },
})
export class RequirePermissionAttributeDirective {

    private readonly authzProvider = inject(AuthorizationProviderService);
    private formControl = inject(NgControl, {self: true, optional: true});

    public dvlibRequirePermission = input.required<UnparsedPermission>();
    public condition = input<boolean>(true);

    public isDisabled$ = combineLatest([
        toObservable(this.dvlibRequirePermission)
            .pipe(switchMap(permission => this.authzProvider.hasPermission$(permission))),
        toObservable(this.condition),
    ]).pipe(
        map(([granted, condition]) => granted && condition),
        map(granted => !granted || null),
    );

    public isDisabled = toSignal(this.isDisabled$, {initialValue: true});

    public constructor() {
        effect(() => {
            if (this.isDisabled()) {
                untracked(() => this.formControl?.control?.disable({onlySelf: true, emitEvent: true}));
            } else {
                untracked(() => this.formControl?.control?.enable({onlySelf: true, emitEvent: true}));
            }
        });
    }
}
